import { render, staticRenderFns } from "./elCopy.vue?vue&type=template&id=58b71064"
import script from "./elCopy.vue?vue&type=script&lang=js"
export * from "./elCopy.vue?vue&type=script&lang=js"
import style0 from "./elCopy.vue?vue&type=style&index=0&id=58b71064&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports